import styled from 'styled-components';

import { colors, transitions } from '../../../styles/theme';

const VideoThumbWrapperStyles = styled.div`
  text-align: left;
  max-width: 200px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  cursor: pointer;
  position: relative;

  a,
  .guides-container-play-button,
  .guides-video-play-button {
    transition: ${transitions('fast')};
  }

  &:hover {
    a {
      color: ${colors('primary.base')};
      transition: ${transitions('fast')};
    }

    .guides-container-play-button {
      background: ${colors('white.base')};
      border-radius: 50%;
      border: 3px solid rgba(255, 255, 255, 0.4);
      box-sizing: border-box;
      transition: ${transitions('fast')};
      width: 58px;
      height: 58px;
    }

    .guides-video-play-button {
      background: url('https://cdn.memed.com.br/icons-onboarding/PNG/play_purple.png');
      background-repeat: no-repeat;
      background-position: center;
      transition: ${transitions('fast')};
    }
  }
`;

export default VideoThumbWrapperStyles;
